var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "323D6DA6-F586-4D16-AA33-A325B16DAA6C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.290196 0 0 0 0 0.290196 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.8-Onboarding---Invite-Colleagues",
    transform: "translate(-1139.000000, -215.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play",
    transform: "translate(1115.000000, 187.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.723586745,15.9773074 C0.32396082,15.9773074 0,15.6521557 0,15.2510638 L0,0.726241135 C0.000244686561,0.454356511 0.151777703,0.205381076 0.39268308,0.0810455003 C0.633588457,-0.0432900758 0.923511571,-0.0221580495 1.14399064,0.135807092 L11.2742051,7.39821844 C11.4639277,7.53459466 11.5764735,7.7544352 11.5764735,7.98865248 C11.5764735,8.22286976 11.4639277,8.44271031 11.2742051,8.57908652 L1.14399064,15.8414979 C1.02164905,15.9301651 0.874490106,15.9777033 0.723586745,15.9773074 Z M1.44717349,2.13732766 L1.44717349,13.8399773 L9.60850838,7.98865248 L1.44717349,2.13732766 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/play.ac92e58c2d3a28f96ca51d8b914e1f7d.svg";